import { render, staticRenderFns } from "./ModalLegends.vue?vue&type=template&id=00ec527b&"
import script from "./ModalLegends.vue?vue&type=script&lang=js&"
export * from "./ModalLegends.vue?vue&type=script&lang=js&"
import style0 from "./ModalLegends.vue?vue&type=style&index=0&id=00ec527b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports